export const environment = {
  production: true,
  apiUrl: 'https://createmydatabook-processor-qa.sbp.eyclienthub.com/api/',
  usApiUrl: 'https://createmydatabook-processor-qa.sbp.eyclienthub.com/api/',
  apacApiUrl: 'https://createmydatabook-processor-qa.sbp.eyclienthub.com/api/',
  pageRows: 10,
  pageRows25: 25,
  maxFilesUploads: 5,
  concurrentUploads: 2,
  maxFileSize: 6, // in MB
  maxSourceFileSize: 10, // in MB
  maxFlatFileSizeUploadLimit: 100,
  minFlatFileSizeToSendEmail: 6144, // in KB =6MB
  maxPreviewFileSize: 512000,//500 KB
  env: 'qa',
  pageSize: 1000,
  tenant: 'eygs.onmicrosoft.com',
  clientId: '7e1d4f2c-d4f4-465b-a748-fb02ed15f984',
  redirectUri: window.location.origin,
  postLogoutRedirectUri: window.location.origin,
  extraQueryParameter: 'domain_hint = eyclienthub.com',
  authority: 'https://login.microsoftonline.com/eygs.onmicrosoft.com',
  isWebJobEnabled: true,
  webjobTimer: 30000,
  isBearerAuthorizationEnabled: true, 
  isMsalEnabled : true,
  sampleToken: '000',
  webAppUrl: 'https://createmydatabook-qa.sbp.eyclienthub.com',
  sessionTimeout: 3540, // in seconds
  processorVersion: 'v3.1',
  version: '16/07/2022 01:20:04 AM EST',
  ENV: 'QA',
  supportedLangs: [{ name: 'English', code: 'en-US' }, { name: 'Español', code: 'es-ES' }]
};
